var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-navigation'),_c('v-content',{attrs:{"id":"content"}},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('app-alert'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }